export default __webpack_public_path__ + "static/News.Default-a89b4a6ca2d1b1bbc0bdaf8106160ab3.png";